module.exports = __webpack_public_path__ + "static/media/vue.9cf6b38f.svg";